const FinBankCreditScoreInfoI18n = {
  scoreInfo: {
    sections: {
      personalData: 'Dados cadastrais pessoa física',
      companyData: 'Dados cadastrais pessoa jurídica',
      contact: 'Contato',
      address: 'Endereço',
    },
    personalData: {
      cpf: 'CPF',
      nome: 'Nome',
      nomeMae: 'Nome da mãe',
      dataNascimento: 'Data de nascimento',
      nacionalidade: 'Nacionalidade',
      obito: 'Óbito',
      escolaridade: 'Escolaridade',
    },
    companyData: {
      cnpj: 'CNPJ',
      razaoSocial: 'Razão social',
      nomeFantasia: 'Nome fantasia',
      natureza: 'Natureza',
      porte: 'Situação CNPJ',
      atividadePrincipal: 'Atividade principal',
      dataAbertura: 'Data da abertura',
      capitalSocial: 'Capital social atual',
      dataCapitalSocial: 'Data da última alteração do capital',
    },
    contact: {
      telefonePrincipal: 'Telefone principal',
      telefoneSecundario: 'Telefone secundário',
    },
    address: {
      itemLabel: 'Endereço {{index}}',
      pageIndicator: '{{current}} de {{total}}',
      rua: 'Rua',
      bairro: 'Bairro',
      cidade: 'Cidade',
      complemento: 'Complemento',
      estado: 'Estado',
      cep: 'CEP',
      empty: 'Nenhum endereço cadastrado',
    },
    consumerStatus: {
      title: 'Status do consumidor',
      subtitleActive: 'Cadastro positivo',
      subtitleInactive: 'Cadastro negativo',
      active: 'Ativo',
      inactive: 'Inativo',
    },
    values: {
      yes: 'Sim',
      no: 'Não',
      notInformed: 'Não informado',
    },
  },
};

export default FinBankCreditScoreInfoI18n;
